import { Stack } from "@mui/material";
import {
  DenominationSummaryFooter,
  DenominationSummaryHeader,
  DenominationSummaryTable
} from "../components";

export const DenominationSummary = () => {
  return (
    <Stack pt={4} spacing={4}>
      <DenominationSummaryHeader />
      <DenominationSummaryTable />
      <DenominationSummaryFooter />
    </Stack>
  );
};
